import React from 'react'

const FileInput = ({ onChange }) => {
  return <input type="file" onChange={onChange} />
}

export default FileInput
